import React from "react";

import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { IconButton, Slider, Stack, Typography, useTheme } from "@mui/material";

import { maxOffset, minOffset } from "../assets/colours";

export default function TransparencySlider({ offset, setOffset }) {
  const theme = useTheme();
  const step = (maxOffset - minOffset) / 100;
  const buttonStep = step * 4;
  const increaseSlider = () => {
    if (offset === maxOffset) {
      return;
    }
    if (offset + buttonStep > maxOffset) {
      setOffset(maxOffset);
      return;
    }
    setOffset((currentOffset) => currentOffset + buttonStep);
  };

  const decreaseSlider = () => {
    if (offset === minOffset) {
      return;
    }
    if (offset - buttonStep < minOffset) {
      setOffset(minOffset);
      return;
    }
    setOffset((currentOffset) => currentOffset - buttonStep);
  };
  return (
    <Stack
      spacing={2}
      direction="row"
      sx={{
        mb: 1,
        ml: 3,
        width: "350px",
        maxWidth: `calc(100% - ${theme.spacing(4)})`,
      }}
      alignItems="center"
    >
      <Typography variant="caption" id="input-slider">
        Transparency:
      </Typography>
      <IconButton
        onClick={decreaseSlider}
        disabled={offset === minOffset}
        color="primary"
      >
        <RemoveCircleIcon />
      </IconButton>
      <Slider
        size="small"
        value={offset}
        aria-label="Transparency"
        valueLabelDisplay="off"
        max={maxOffset}
        min={minOffset}
        step={step}
        onChange={(event) => {
          setOffset(event.target.value);
        }}
      />
      <IconButton
        onClick={increaseSlider}
        disabled={offset === maxOffset}
        color="primary"
      >
        <AddCircleIcon />
      </IconButton>
    </Stack>
  );
}
